import agent from "./agent";
import { getPlaceId, getConfigId } from "../Store/Auth/selector";

// general setting
export function getBookingFee() {
  return agent.get("configs/getBookingFee");
}

export function editBookingFee(body) {
  return agent.put(`configs/${getConfigId()}/edit`, body);
}

// account management
export function getAccountManagement(search, sort, skip, limit) {
  return agent.get(`accounts/getListStaff`, {
    params: { filter: { search }, sort, skip: skip * limit, limit },
  });
}

export function inviteAccountManagement(body) {
  return agent.post("accounts/inviteMember", { ...body });
}

export function changePassAccountManagement(body) {
  return agent.post("accounts/change-password", { ...body });
}

export function editAccountManagement(id, body) {
  return agent.put(`accounts/${id}/editStaff`, { ...body });
}

// hak akses
export function getHakAkses(search, skip, limit) {
  return agent.get(`access/getList`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addHakAkses(body) {
  return agent.post("access/add", { ...body, placeId: getPlaceId() });
}

export function editHakAkses(id, body) {
  return agent.put(`access/${id}/edit`, { ...body, placeId: getPlaceId() });
}

export function deleteHakAkses(id) {
  return agent.put(`access/${id}/delete`);
}

// tipe membership
export function getTipeMembership(skip, limit) {
  return agent.get(`membershipDatas`, {
    params: { skip: skip * limit, limit },
  });
}

export function editTipeMembership(id, body) {
  return agent.put(`membershipDatas/${id}/edit`, { ...body });
}

// kategori tindakan
export function getKategoriTindakan(search, skip, limit) {
  return agent.get(`categories/getListAction`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addKategoriTindakan(body) {
  return agent.post("categories/addAction", { ...body });
}

export function editKategoriTindakan(id, body) {
  return agent.put(`categories/${id}/editAction`, { ...body });
}

export function deleteKategoriTindakan(id) {
  return agent.put(`categories/${id}/deleteAction`);
}

export function getKlinikAll(search) {
  return agent.get(`places/getList`, {
    params: { filter: { search } },
  });
}

// kategori promo
export function getKategoriPromo(search, skip, limit) {
  return agent.get(`categories/getListPromo`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addKategoriPromo(body) {
  return agent.post("categories/addPromo", { ...body });
}

export function editKategoriPromo(id, body) {
  return agent.put(`categories/${id}/editPromo`, { ...body });
}

export function deleteKategoriPromo(id) {
  return agent.put(`categories/${id}/deletePromo`);
}

// Jenis Promo
export function getJenisPromo(search, skip, limit) {
  return agent.get(`categories/getTypePromo`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addJenisPromo(body) {
  return agent.post("categories/addTypePromo", { ...body });
}

export function editJenisPromo(id, body) {
  return agent.put(`categories/${id}/editTypePromo`, { ...body });
}

export function deleteJenisPromo(id) {
  return agent.put(`categories/${id}/deleteTypePromo`);
}

// Tipe Pembayaran Promo
export function getTipePembyaranPromo(search, skip, limit) {
  return agent.get(`categories/getPaymentTypePromo`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addTipePembayaranPromo(body) {
  return agent.post("categories/addPaymentTypePromo", { ...body });
}

export function editTipePembayaranPromo(id, body) {
  return agent.put(`categories/${id}/editPaymentTypePromo`, { ...body });
}

export function deleteTipePembayaranPromo(id) {
  return agent.put(`categories/${id}/deletePaymentTypePromo`);
}


// kategori gallery
export function getKategoriGallery(search, skip, limit) {
  return agent.get(`categories/getListGallery`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addKategoriGallery(body) {
  return agent.post("categories/addGallery", { ...body });
}

export function editKategoriGallery(id, body) {
  return agent.put(`categories/${id}/editGallery`, { ...body });
}

export function deleteKategoriGallery(id) {
  return agent.put(`categories/${id}/deleteGallery`);
}

// kategori video
export function getKategoriVideo(search, skip, limit) {
  return agent.get(`categories/getListVideo`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addKategoriVideo(body) {
  return agent.post("categories/addVideo", { ...body });
}

export function editKategoriVideo(id, body) {
  return agent.put(`categories/${id}/editVideo`, { ...body });
}

export function deleteKategoriVideo(id) {
  return agent.put(`categories/${id}/deleteVideo`);
}

// kategori faq
export function getKategoriFAQS(search, skip, limit) {
  return agent.get(`categories/getListFaqs`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addKategoriFAQS(body) {
  return agent.post("categories/addFaqs", { ...body });
}

export function editKategoriFAQS(id, body) {
  return agent.put(`categories/${id}/editFaqs`, { ...body });
}

export function deleteKategoriFAQS(id) {
  return agent.put(`categories/${id}/deleteFaqs`);
}

// kategori artikel
export function getKategoriArtikel(search, skip, limit) {
  return agent.get(`categories/getListArticle`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addKategoriArtikel(body) {
  return agent.post("categories/addArticle", { ...body });
}

export function editKategoriArtikel(id, body) {
  return agent.put(`categories/${id}/editArticle`, { ...body });
}

export function deleteKategoriArtikel(id) {
  return agent.put(`categories/${id}/deleteArticle`);
}

// kategori asuransi
export function getKategoriAsuransi(search, skip, limit) {
  return agent.get(`categories/getListAsuransi`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addKategoriAsuransi(body) {
  return agent.post("categories/addAsuransi", { ...body });
}

export function editKategoriAsuransi(id, body) {
  return agent.put(`categories/${id}/editAsuransi`, { ...body });
}

export function deleteKategoriAsuransi(id) {
  return agent.put(`categories/${id}/deleteAsuransi`);
}

// kategori Wilayah
export function getKategoriWilayah(search, skip, limit) {
  return agent.get(`categories/getListWilayah`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addKategoriWilayah(body) {
  return agent.post("categories/addWilayah", { ...body });
}

export function editKategoriWilayah(id, body) {
  return agent.put(`categories/${id}/editWilayah`, { ...body });
}

export function deleteKategoriWilayah(id) {
  return agent.put(`categories/${id}/deleteWilayah`);
}

// kategori onboarding

export function getKategoriOnboarding(search, skip, limit) {
  return agent.get(`categories/getListOnboarding`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addKategoriOnboarding(body) {
  return agent.post("categories/addOnboarding", { ...body });
}

export function editKategoriOnboarding(id, body) {
  return agent.put(`categories/${id}/editOnboarding`, { ...body });
}

export function deleteKategoriOnboarding(id) {
  return agent.put(`categories/${id}/deleteOnboarding`);
}

// Kategori Dokter
export function getKategoriDokter(search, skip, limit) {
  return agent.get(`categories/getDoctorType`, {
    params: { filter: { search }, skip: skip * limit, limit },
  });
}

export function addKategoriDokter(body) {
  return agent.post("categories/addDoctorType", { ...body });
}

export function editKategoriDokter(id, body) {
  return agent.put(`categories/${id}/editDoctorType`, { ...body });
}

export function deleteKategoriDokter(id) {
  return agent.put(`categories/${id}/deleteDoctorType`);
}

// general setting for documents
export function getGeneralSetting(fieldName) {
  return agent.get(`general-setting/${fieldName}`);
}

export function updateGeneralSetting(fieldName, body) {
  return agent.put(`general-setting/${fieldName}`, body);
}
